import {
  Banknote,
  Building2,
  Calculator,
  FileCheck,
  FileDigit,
  FileIcon,
  FileSpreadsheet,
  FileText,
  IdCard,
  Landmark,
  type LucideIcon,
} from "lucide-react";

/** Lucide components for the icon names the server catalog uses. */
const DOCUMENT_ICONS: Readonly<Record<string, LucideIcon>> = {
  banknote: Banknote,
  "building-2": Building2,
  calculator: Calculator,
  file: FileIcon,
  "file-check": FileCheck,
  "file-digit": FileDigit,
  "file-spreadsheet": FileSpreadsheet,
  "id-card": IdCard,
  landmark: Landmark,
};

/** A name this build does not know yet shows a plain file. */
export function documentIcon(name: string): LucideIcon {
  return DOCUMENT_ICONS[name] ?? FileText;
}
